import PropTypes from 'prop-types';
import React, { useRef, useCallback } from 'react';
import { List } from 'immutable';

import { CURRENCY_SHORT_SYMBOLS } from '../../../constants';

import RadioButton, { RadioButtonOption } from '../RadioButton';

import styles from './CurrencySelector.module.scss';

export default function CurrencySelector({
  className = '',
  name,
  label,
  onChange,
  value,
  errors = new List(),
  currencies,
}) {
  const field = useRef();

  const handleChange = useCallback((newValue) => {
    onChange({
      name,
      value: newValue,
    });
  });

  const renderErrors = useCallback(() => {
    const err = errors.map(message => {
      const key = message.field ? message.field : '';
      const text = message.field ? message.messages : message;
      const finalText = typeof text === 'string' ? text.replace(/;\s*$/, '') : text[0];
      return (
        <span
          key={key}
          className={styles.errorMessage}
        >
          {finalText}
        </span>
      );
    });

    return (
      <div className={styles.containerMessages}>
        {err}
      </div>
    );
  }, [errors]);

  let inputErrors = renderErrors();

  if (errors.length !== 0) {
    inputErrors = null;
  }

  const fieldClass = [
    styles.field,
    className,
  ].join(' ');

  return (
    <div className={fieldClass}>
      <div
        className={styles.property}
        ref={field}
      >
        <span className={styles.label}>{label}</span>
        <RadioButton
          onChange={handleChange}
          value={value}
          fluid
        >
          {currencies.map(currency => (
            <RadioButtonOption
              key={currency.id}
              label={`${CURRENCY_SHORT_SYMBOLS[currency.id]}${currency.name}`}
              value={currency.id}
              dataHook={`register-curr-${currency.id.toLowerCase()}`}
            />
          ))}
        </RadioButton>
        {inputErrors}
      </div>
    </div>
  );
}

CurrencySelector.propTypes = {
  className: PropTypes.string,
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  value: PropTypes.any.isRequired,
  currencies: PropTypes.instanceOf(List).isRequired,
  errors: PropTypes.array,
};
